import { VStack, Box } from '@cad-arc';
import { ScheduledEventDetailsSectionContent } from '../../event-panel/tabs/event-details/components/sections/scheduled-event-details-section-content';
import { SectionTitle } from '../../fr-event-common-components/section-title';

export function FrScheduledEventDetailsSection({ receivedDateUtc }: { receivedDateUtc?: string }) {
    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title="Scheduled Event Details" />
            <Box w="100%">
                <ScheduledEventDetailsSectionContent receivedDateUtc={receivedDateUtc} />
            </Box>
        </VStack>
    );
}
